<script>
  import { Router, Route,Link,link } from "svelte-routing";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";

  import MenuConfig from "./viewanalytics.svelte";
  import Configurar from "./configurar.svelte";


</script>
<Router >
    <main>
      <!-- You are here: <code>{path}</code> -->
      <Route path="/menu" component={MenuConfig}/>
      <Route path="/configurar" component={Configurar}/>

    </main>
  </Router>